export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="max-w-3xl mx-auto lg:mx-0">
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-6">
            Votre réparateur de fenêtre à Lingolsheim
          </h2>
          <div className="space-y-4 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Lingolsheim, à l'ouest de Strasbourg, est un territoire de pavillons et de jardins. Les fenêtres y vieillissent au fil des hivers et des étés, entre les lotissements récents et les maisons plus anciennes. Nos techniciens interviennent à domicile, pièce comprise, déplacement gratuit.
            </p>
            <p>
              Lingolsheim, à l'ouest de Strasbourg, est un territoire de pavillons et de jardins. Les lotissements récents côtoient les maisons plus anciennes du centre-ville. Les fenêtres y vieillissent au fil des hivers et des étés, entre le PVC moderne et le bois traditionnel. Nous connaissons bien cette commune et intervenons chez vous pour réparer le mécanisme.
            </p>
            <p>
              Notre atelier de Strasbourg est à quelques minutes. Nous réparons le mécanisme dans plus de 90 % des cas, sans remplacer la fenêtre entière. C'est plus rapide, plus écologique et bien moins cher. Déplacement et devis gratuits, pièce comprise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}